/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CaseNoteEdictResponse,
  CaseNoteHistoryResponse,
  CaseNoteResponse,
  CreateCaseNoteFromDocumentRequest,
  CreateCaseNoteFromEmailRequest,
  CreateCaseNoteRequest,
  FileStreamResult,
  ProblemDetails,
  UpdateCaseNoteFromDocumentRequest,
  UpdateCaseNoteRequest,
  ValidationProblemDetails,
} from '../models/index';
import {
    CaseNoteEdictResponseFromJSON,
    CaseNoteEdictResponseToJSON,
    CaseNoteHistoryResponseFromJSON,
    CaseNoteHistoryResponseToJSON,
    CaseNoteResponseFromJSON,
    CaseNoteResponseToJSON,
    CreateCaseNoteFromDocumentRequestFromJSON,
    CreateCaseNoteFromDocumentRequestToJSON,
    CreateCaseNoteFromEmailRequestFromJSON,
    CreateCaseNoteFromEmailRequestToJSON,
    CreateCaseNoteRequestFromJSON,
    CreateCaseNoteRequestToJSON,
    FileStreamResultFromJSON,
    FileStreamResultToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateCaseNoteFromDocumentRequestFromJSON,
    UpdateCaseNoteFromDocumentRequestToJSON,
    UpdateCaseNoteRequestFromJSON,
    UpdateCaseNoteRequestToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CreateCaseNoteOperationRequest {
    clientId: string;
    createCaseNoteRequest: CreateCaseNoteRequest;
}

export interface CreateCaseNoteFromDocumentOperationRequest {
    clientId: string;
    createCaseNoteFromDocumentRequest: CreateCaseNoteFromDocumentRequest;
}

export interface CreateCaseNoteFromEmailOperationRequest {
    clientId: string;
    createCaseNoteFromEmailRequest: CreateCaseNoteFromEmailRequest;
}

export interface DeleteCaseNoteRequest {
    clientId: string;
    noteId: string;
}

export interface DownloadAllCaseNotesRequest {
    clientId: string;
}

export interface GetCaseNoteEdictRequest {
    clientId: string;
    noteId: string;
}

export interface GetCaseNoteHistoryRequest {
    clientId: string;
    noteId: string;
}

export interface GetCaseNotePrintDocumentRequest {
    clientId: string;
    noteId: string;
}

export interface GetCaseNotesByClientIdRequest {
    clientId: string;
    searchParam?: string;
    appointmentNotesOnly?: boolean;
}

export interface UpdateCaseNoteOperationRequest {
    clientId: string;
    noteId: string;
    updateCaseNoteRequest: UpdateCaseNoteRequest;
}

export interface UpdateCaseNoteFromDocumentOperationRequest {
    clientId: string;
    noteId: string;
    updateCaseNoteFromDocumentRequest: UpdateCaseNoteFromDocumentRequest;
}

/**
 * CaseNotesApi - interface
 * 
 * @export
 * @interface CaseNotesApiInterface
 */
export interface CaseNotesApiInterface {
    /**
     * 
     * @param {string} clientId 
     * @param {CreateCaseNoteRequest} createCaseNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    createCaseNoteRaw(requestParameters: CreateCaseNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteResponse>>;

    /**
     */
    createCaseNote(requestParameters: CreateCaseNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {CreateCaseNoteFromDocumentRequest} createCaseNoteFromDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    createCaseNoteFromDocumentRaw(requestParameters: CreateCaseNoteFromDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteResponse>>;

    /**
     */
    createCaseNoteFromDocument(requestParameters: CreateCaseNoteFromDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {CreateCaseNoteFromEmailRequest} createCaseNoteFromEmailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    createCaseNoteFromEmailRaw(requestParameters: CreateCaseNoteFromEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    createCaseNoteFromEmail(requestParameters: CreateCaseNoteFromEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    deleteCaseNoteRaw(requestParameters: DeleteCaseNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    deleteCaseNote(requestParameters: DeleteCaseNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @param {string} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    downloadAllCaseNotesRaw(requestParameters: DownloadAllCaseNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>>;

    /**
     */
    downloadAllCaseNotes(requestParameters: DownloadAllCaseNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    getCaseNoteEdictRaw(requestParameters: GetCaseNoteEdictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteEdictResponse>>;

    /**
     */
    getCaseNoteEdict(requestParameters: GetCaseNoteEdictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteEdictResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    getCaseNoteHistoryRaw(requestParameters: GetCaseNoteHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CaseNoteHistoryResponse>>>;

    /**
     */
    getCaseNoteHistory(requestParameters: GetCaseNoteHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CaseNoteHistoryResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} noteId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    getCaseNotePrintDocumentRaw(requestParameters: GetCaseNotePrintDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>>;

    /**
     */
    getCaseNotePrintDocument(requestParameters: GetCaseNotePrintDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} [searchParam] 
     * @param {boolean} [appointmentNotesOnly] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    getCaseNotesByClientIdRaw(requestParameters: GetCaseNotesByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CaseNoteResponse>>>;

    /**
     */
    getCaseNotesByClientId(requestParameters: GetCaseNotesByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CaseNoteResponse>>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} noteId 
     * @param {UpdateCaseNoteRequest} updateCaseNoteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    updateCaseNoteRaw(requestParameters: UpdateCaseNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteResponse>>;

    /**
     */
    updateCaseNote(requestParameters: UpdateCaseNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteResponse>;

    /**
     * 
     * @param {string} clientId 
     * @param {string} noteId 
     * @param {UpdateCaseNoteFromDocumentRequest} updateCaseNoteFromDocumentRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CaseNotesApiInterface
     */
    updateCaseNoteFromDocumentRaw(requestParameters: UpdateCaseNoteFromDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteResponse>>;

    /**
     */
    updateCaseNoteFromDocument(requestParameters: UpdateCaseNoteFromDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteResponse>;

}

/**
 * 
 */
export class CaseNotesApi extends runtime.BaseAPI implements CaseNotesApiInterface {

    /**
     */
    async createCaseNoteRaw(requestParameters: CreateCaseNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createCaseNote().'
            );
        }

        if (requestParameters['createCaseNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaseNoteRequest',
                'Required parameter "createCaseNoteRequest" was null or undefined when calling createCaseNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/notes`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCaseNoteRequestToJSON(requestParameters['createCaseNoteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseNoteResponseFromJSON(jsonValue));
    }

    /**
     */
    async createCaseNote(requestParameters: CreateCaseNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteResponse> {
        const response = await this.createCaseNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCaseNoteFromDocumentRaw(requestParameters: CreateCaseNoteFromDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createCaseNoteFromDocument().'
            );
        }

        if (requestParameters['createCaseNoteFromDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaseNoteFromDocumentRequest',
                'Required parameter "createCaseNoteFromDocumentRequest" was null or undefined when calling createCaseNoteFromDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/notes/from-document`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCaseNoteFromDocumentRequestToJSON(requestParameters['createCaseNoteFromDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseNoteResponseFromJSON(jsonValue));
    }

    /**
     */
    async createCaseNoteFromDocument(requestParameters: CreateCaseNoteFromDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteResponse> {
        const response = await this.createCaseNoteFromDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async createCaseNoteFromEmailRaw(requestParameters: CreateCaseNoteFromEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling createCaseNoteFromEmail().'
            );
        }

        if (requestParameters['createCaseNoteFromEmailRequest'] == null) {
            throw new runtime.RequiredError(
                'createCaseNoteFromEmailRequest',
                'Required parameter "createCaseNoteFromEmailRequest" was null or undefined when calling createCaseNoteFromEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/notes/from-email`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateCaseNoteFromEmailRequestToJSON(requestParameters['createCaseNoteFromEmailRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async createCaseNoteFromEmail(requestParameters: CreateCaseNoteFromEmailOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createCaseNoteFromEmailRaw(requestParameters, initOverrides);
    }

    /**
     */
    async deleteCaseNoteRaw(requestParameters: DeleteCaseNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling deleteCaseNote().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling deleteCaseNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/notes/{noteId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteCaseNote(requestParameters: DeleteCaseNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteCaseNoteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async downloadAllCaseNotesRaw(requestParameters: DownloadAllCaseNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling downloadAllCaseNotes().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/notes/archive`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileStreamResultFromJSON(jsonValue));
    }

    /**
     */
    async downloadAllCaseNotes(requestParameters: DownloadAllCaseNotesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult> {
        const response = await this.downloadAllCaseNotesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCaseNoteEdictRaw(requestParameters: GetCaseNoteEdictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteEdictResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getCaseNoteEdict().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling getCaseNoteEdict().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/notes/{noteId}/edict`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseNoteEdictResponseFromJSON(jsonValue));
    }

    /**
     */
    async getCaseNoteEdict(requestParameters: GetCaseNoteEdictRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteEdictResponse> {
        const response = await this.getCaseNoteEdictRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCaseNoteHistoryRaw(requestParameters: GetCaseNoteHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CaseNoteHistoryResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getCaseNoteHistory().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling getCaseNoteHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/notes/{noteId}/history`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CaseNoteHistoryResponseFromJSON));
    }

    /**
     */
    async getCaseNoteHistory(requestParameters: GetCaseNoteHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CaseNoteHistoryResponse>> {
        const response = await this.getCaseNoteHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCaseNotePrintDocumentRaw(requestParameters: GetCaseNotePrintDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FileStreamResult>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getCaseNotePrintDocument().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling getCaseNotePrintDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/notes/{noteId}/print`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FileStreamResultFromJSON(jsonValue));
    }

    /**
     */
    async getCaseNotePrintDocument(requestParameters: GetCaseNotePrintDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FileStreamResult> {
        const response = await this.getCaseNotePrintDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCaseNotesByClientIdRaw(requestParameters: GetCaseNotesByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CaseNoteResponse>>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling getCaseNotesByClientId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['searchParam'] != null) {
            queryParameters['searchParam'] = requestParameters['searchParam'];
        }

        if (requestParameters['appointmentNotesOnly'] != null) {
            queryParameters['appointmentNotesOnly'] = requestParameters['appointmentNotesOnly'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/clients/{clientId}/notes`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CaseNoteResponseFromJSON));
    }

    /**
     */
    async getCaseNotesByClientId(requestParameters: GetCaseNotesByClientIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CaseNoteResponse>> {
        const response = await this.getCaseNotesByClientIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCaseNoteRaw(requestParameters: UpdateCaseNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateCaseNote().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling updateCaseNote().'
            );
        }

        if (requestParameters['updateCaseNoteRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCaseNoteRequest',
                'Required parameter "updateCaseNoteRequest" was null or undefined when calling updateCaseNote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/notes/{noteId}`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCaseNoteRequestToJSON(requestParameters['updateCaseNoteRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseNoteResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateCaseNote(requestParameters: UpdateCaseNoteOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteResponse> {
        const response = await this.updateCaseNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateCaseNoteFromDocumentRaw(requestParameters: UpdateCaseNoteFromDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CaseNoteResponse>> {
        if (requestParameters['clientId'] == null) {
            throw new runtime.RequiredError(
                'clientId',
                'Required parameter "clientId" was null or undefined when calling updateCaseNoteFromDocument().'
            );
        }

        if (requestParameters['noteId'] == null) {
            throw new runtime.RequiredError(
                'noteId',
                'Required parameter "noteId" was null or undefined when calling updateCaseNoteFromDocument().'
            );
        }

        if (requestParameters['updateCaseNoteFromDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'updateCaseNoteFromDocumentRequest',
                'Required parameter "updateCaseNoteFromDocumentRequest" was null or undefined when calling updateCaseNoteFromDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/clients/{clientId}/notes/{noteId}/from-document`;
        urlPath = urlPath.replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters['clientId'])));
        urlPath = urlPath.replace(`{${"noteId"}}`, encodeURIComponent(String(requestParameters['noteId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateCaseNoteFromDocumentRequestToJSON(requestParameters['updateCaseNoteFromDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CaseNoteResponseFromJSON(jsonValue));
    }

    /**
     */
    async updateCaseNoteFromDocument(requestParameters: UpdateCaseNoteFromDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CaseNoteResponse> {
        const response = await this.updateCaseNoteFromDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
